// autogenerated by channel_search/generate.py -- do not edit
import { SubscribedChannelList } from "@skydio/pbtypes/pbtypes/infrastructure/skybus_tunnel/tunnel_pb";
export { SubscribedChannelList };

export const WEBRTC_SUBSCRIPTION_LIST_PB = {
  channel: "WEBRTC_SUBSCRIPTION_LIST_PB",
  channelId: 14316,
  type: SubscribedChannelList.deserializeBinary
};
